const assignments_url = process.env.VUE_APP_USER_PROPERTY_ASSIGNMENTS_URL || "";
const assign_properties_to_user_url = process.env.VUE_APP_ASSIGN_PROPERTIES_TO_USER_URL || "";

export async function fetch_user_property_assignments(user_id, headers = {}, params = {}) {
    if (!assignments_url || !user_id) {
        return [];
    }

    const url = new URL(assignments_url);
    url.searchParams.set("user_id", user_id);

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            url.searchParams.set(key, value);
        }
    });

    const response = await fetch(url.toString(), {
        method: "GET",
        headers
    });
    const data = await response.json().catch(() => ([]));

    if (!response.ok) {
        return [];
    }

    return Array.isArray(data) ? data : data.results || data.data || [];
}

export function get_assignment_property_ids(assignments = []) {
    return assignments
        .map((assignment) => assignment?.property_id || assignment?.property?.id)
        .filter(Boolean);
}

export function get_assignment_properties(assignments = [], property_options = []) {
    return get_assignment_property_ids(assignments)
        .map((property_id) => {
            return property_options.find((property) => String(property.id) === String(property_id))
                || { id: property_id, name: String(property_id) };
        });
}

export async function sync_user_property_assignments(user_id, property_ids = [], headers = {}) {
    if (!assign_properties_to_user_url || !user_id || !property_ids.length) {
        return null;
    }

    const response = await fetch(assign_properties_to_user_url, {
        method: "POST",
        headers,
        body: JSON.stringify({
            user_id,
            property_ids
        })
    });
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(data?.message || data?.detail || data?.error || "Unable to assign properties.");
    }

    return data;
}
